import { EditActions, EditActionsEnum } from "../actions/editActions";
import { toggleChildInitialState } from "./initialState";

const toggleChildReducer = (
  state: State.ToggleChildView = toggleChildInitialState,
  action: EditActions
): State.ToggleChildView => {
  switch (action.type) {
    case EditActionsEnum.TOGGLE_CHILD_VIEW: {
      return { ...state, isChildOpen: !state.isChildOpen };
    }
    default:
      return state;
  }
};

export default toggleChildReducer;
